import { render, staticRenderFns } from "./PaymentProviderDetail.vue?vue&type=template&id=005f67e4&scoped=true&"
import script from "./PaymentProviderDetail.vue?vue&type=script&lang=js&"
export * from "./PaymentProviderDetail.vue?vue&type=script&lang=js&"
import style0 from "./PaymentProviderDetail.vue?vue&type=style&index=0&id=005f67e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005f67e4",
  null
  
)

export default component.exports